// @flow
import Cookies from "js-cookie"

export const AFFILID_FALLBACK = "skypicker"

// Safe affilid with "skypicker" default fallback
// @deprecated use getAffilId from options/selector instead
export const SAFE_AFFILID =
  Cookies.get("SKYPICKER_AFFILIATE") ||
  (typeof window !== "undefined" &&
    window.SP_GLOBALS &&
    window.SP_GLOBALS.SKYPICKER_AFFILIATE !== "undefined" &&
    window.SP_GLOBALS.SKYPICKER_AFFILIATE) ||
  AFFILID_FALLBACK

// isEqual to set affilid
// SAFE_AFFILID @deprecated, pass always with setAffilid
export const isSetAffilId = (affilId: string, setAffilid: string = SAFE_AFFILID) =>
  setAffilid === affilId || (Boolean(setAffilid) && setAffilid.startsWith(`${affilId}_`))

export const isSubAffilId = (affilId: string, subAffilId: string) =>
  affilId === subAffilId || (Boolean(affilId) && affilId.startsWith(`${subAffilId}_`))

export const isAffilIdEqual = (a: string, b: string) =>
  a && b && (isSubAffilId(a, b) || isSubAffilId(b, a))

// BizDev agreed priority of getting affilId
// 0. AffilId in URL
// 1. AffilId in Cookies
// 2. User AffilId from BE
// 3. Branding affilid fallback
// 4. Should not be needed "skypicker" fallback
export const getAffilidAccordingToPriority = (
  affilIdRequest?: string,
  affilIdCookies?: string,
  affilIdUser?: string,
  affilIdBranding?: string,
  affilCustomFallback?: string,
) =>
  affilIdRequest ||
  affilIdCookies ||
  affilIdUser ||
  affilIdBranding ||
  affilCustomFallback ||
  AFFILID_FALLBACK

// Discard market information `skypicker_cz` -> `skypicker`
export const formatSimpleAffilId = (affilId?: ?string) =>
  affilId && affilId.includes("_") ? affilId.split("_")[0] : affilId
